import React from 'react';
import { useCapabilities } from '../../../../hooks/useCapabilities';

export type LeadChatHistoryItem = {
  chatId: string;
  title: string;
  updatedAt: string;
  messageCount: number;
  source: 'derived' | 'explicit';
};

export function useLeadProjectChats(leadId: string | null | undefined): {
  chats: LeadChatHistoryItem[];
  canViewChats: boolean;
} {
  const { can, loaded } = useCapabilities();
  const canViewChats = loaded && can('web.kichat.view');
  const [chats, setChats] = React.useState<LeadChatHistoryItem[]>([]);

  React.useEffect(() => {
    if (!canViewChats || !leadId) {
      setChats([]);
      return;
    }
    let cancelled = false;
    void (async () => {
      try {
        const res = await fetch(`/api/leads/${encodeURIComponent(leadId)}/chats`, { credentials: 'include' });
        if (!res.ok) {
          if (!cancelled) setChats([]);
          return;
        }
        const data = (await res.json()) as { chats?: LeadChatHistoryItem[] };
        if (!cancelled) setChats(Array.isArray(data.chats) ? data.chats : []);
      } catch {
        if (!cancelled) setChats([]);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [canViewChats, leadId]);

  return { chats, canViewChats };
}
